export default "__VITE_ASSET__2XEszMNB__"